// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about-us-m__wrapper__49dtt","youtube-wrapper":"about-us-m__youtube-wrapper__Je6Q2","summary":"about-us-m__summary__1HyaY","description":"about-us-m__description__3oe7C"};